<template>
  <section
    class="section section-light is-fullheight animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->

      <div
        class="columns is-vcentered"
        v-if="
          !requestloading &&
          !requestsuccess &&
          !confirmrequest &&
          !changerequest
        "
      >
        <div class="column is-6 is-offset-3 mt-40 mb-40">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded info mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">info</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <h1 class="title is-4">رجاء ادخال كلمة سر جديدة</h1>

              <div class="field-body">
                <div class="field has-addons is-fullwidth">
                  <p class="control is-expanded">
                    <input
                      v-model="changerequestInfo.password"
                      class="input has-text-centered is-large"
                      v-validate="'required|min:6|max:32'"
                      name="password"
                      type="password"
                      placeholder="كلمة السر"
                      ref="password"
                    />
                  </p>
                </div>
              </div>

              <div class="field-body">
                <div class="field has-addons is-fullwidth">
                  <p class="control is-expanded">
                    <input
                      class="input has-text-centered is-large mt-20"
                      v-validate="'required|confirmed:password'"
                      name="password_confirmation"
                      type="password"
                      placeholder="تأكيد كلمة السر"
                    />
                  </p>
                </div>
              </div>
              <span
                class="help is-danger has-text-centered mt-10"
                v-show="errors.any()"
              >
                <div v-if="errors.has('password')">
                  {{ errors.first("password") }}
                </div>
                <div v-if="errors.has('password_confirmation')">
                  {{ errors.first("password_confirmation") }}
                </div>
              </span>
            </div>

            <div class="hero-foot has-text-centered mt-40 mb-20">
              <a
                class="button btn secondary-btn raised btn-align modal-dismiss is-bold is-medium"
                v-on:click="validateBeforeSubmit()"
              >
                <b>تأكيد كلمة السر والاستمرار</b>
              </a>
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-centered has-text-centered"
        v-else-if="
          requestloading && !requestsuccess && !confirmrequest && !changerequest
        "
      >
        <loading
          font-size="20"
          line-fg-color="var(--primary-color)"
          size="massive"
          class="margin-100"
          text-fg-color="#2d3f51"
          message="الرجاء الإنتظار"
        />
      </div>
      <div
        class="columns is-vcentered"
        v-else-if="
          !requestloading && !requestsuccess && confirmrequest && !changerequest
        "
      >
        <div class="column is-6 is-offset-3 mt-40 mb-40">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded info mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">info</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <form @submit.prevent="sendchangerequest()">
                <div class="field">
                  <div class="control">
                    <input
                      v-model="changerequestInfo.code"
                      name="code"
                      class="input has-text-centered has-text-black is-large"
                      type="text"
                      placeholder=" كود التفعيل"
                      autofocus
                      v-validate="'required|numeric'"
                      :class="{ input: true, 'is-danger': errors.has('code') }"
                    />
                    <span
                      v-show="errors.has('code')"
                      class="help is-danger is-centered"
                      >{{ errors.first("code") }}</span
                    >
                  </div>
                </div>

                <div class="mt-20">
                  <!-- <router-link to="/book" >   <a class="button  is-info is-large is-fullwidth raised "> تأكيد </a></router-link> -->
                  <button
                    class="button is-rounded is-info is-wati is-large is-fullwidth"
                    type="submit"
                    v-bind:class="{ 'is-loading': requestloading }"
                  >
                    تأكيد
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-centered has-text-centered"
        v-else-if="
          requestloading && !requestsuccess && confirmrequest && !changerequest
        "
      >
        <loading
          font-size="20"
          line-fg-color="var(--primary-color)"
          size="massive"
          class="margin-100"
          text-fg-color="#2d3f51"
          message="الرجاء الإنتظار"
        />
      </div>
      <div
        class="columns is-vcentered"
        v-if="
          requestsuccess && !requestloading && confirmrequest && changerequest
        "
      >
        >
        <div class="column is-6 is-offset-3 mt-80 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded primary mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <h1 class="title is-4 pb-10">تم تغير كلمة السر بنجاح</h1>
              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-vcentered"
        v-else-if="
          !requestsuccess && !requestloading && confirmrequest && changerequest
        "
      >
        <div class="column is-6 is-offset-3 mt-40 mb-90">
          <!-- Login form -->
          <div class="flex-card raised padding-20">
            <div class="square-icon-box rounded danger mt-20">
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <hr />
              <h1 class="title is-4 pb-10">فشل في تغير كلمة السر</h1>

              <h1 class="subtitle is-5">
                رقم السري الذي ادخلته غير صحيح رجاء المحاولة مرة اخرى
              </h1>

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";

export default {
  data() {
    return {
      email: false,
      confirmpassword: null,
      confirmrequestInfo: {
        userID: null,
        token: null,
      },
      changerequestInfo: {
        userID: null,
        password: null,
        code: null,
        token: null,
      },
      requestloading: false,
      requestsuccess: false,
      confirmrequest: false,
      changerequest: false,
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.cardentered = true;
          this.sendconfirmrequest();
          return;
        }
      });
    },
    sendconfirmrequest() {
      this.requestloading = !this.requestloading;

      var user = JSON.parse(localStorage.getItem("user"));

      this.confirmrequestInfo.userID = user[1];

      this.confirmrequestInfo.token = localStorage.getItem("token");

      axios
        .post("password/GetConfirmationCode", this.confirmrequestInfo)
        .then((response) => {
          this.$root.kick(response.data.message);
          console.log(response.data);
          if (response.data.status == "success") {
            this.requestloading = !this.requestloading;

            this.confirmrequest = true;

            // alert("request sent successfully");
          } else if (response.data.status == "fail") {
            this.requestsuccess = false;

            // alert("request fail");
          }
          console.log(this.confirmrequestInfo);
        })
        .catch((error) => {
          this.requestloading = !this.requestloading;
          this.message = true;
        });
    },
    sendchangerequest() {
      this.requestloading = !this.requestloading;

      var user = JSON.parse(localStorage.getItem("user"));

      this.changerequestInfo.userID = user[1];

      this.changerequestInfo.token = localStorage.getItem("token");

      console.log(this.changerequestInfo);
      axios
        .post("password/change", this.changerequestInfo)
        .then((response) => {
          this.$root.kick(response.data.message);
          console.log(response);
          if (response.data.status == "success") {
            this.changerequest = true;
            this.requestloading = false;
            this.requestsuccess = true;
            this.changerequest = true;
          } else if (response.data.status == "fail") {
            this.changerequest = true;
            this.requestloading = false;
            this.requestsuccess = false;
            this.changerequest = true;
          }
        })
        .catch((error) => {
          console.log(error);

          this.changerequest = true;
          this.requestloading = false;
          this.requestsuccess = false;
          this.changerequest = true;
        });
    },
  },
  created() {
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        password: "كلمة السر",
        password_confirmation: "تأكيد كلمة السر",
      },
      custom: {
        password_confirmation: {
          confirmed: "كلمات السر غير متطابقة",
          required: "حقل تأكيد كلمة السر مطلوب",
        },
      },
    });
  },
};
</script>
